import * as _ from 'lodash';
import WageAndTravelList from './components/wage-and-travel-list';
import WatrNav from './components/nav';
import VerifyPage from './components/verify/page';
import { WatrPage, WatrPagePanel } from './styles';
import './components/document-viewer/viewer.css';

interface IProps {
    section: string,
    subSection?: string,
    centerId: number,
    isSuperUser: boolean,
    requestId?: number
}

const WageAndTravel = (props: IProps) => {
    const handleTabSelect = (key: string) => { };

    var activeKey = props.section.toUpperCase();

    return (
        <WatrPage>
            <WatrNav
                activeKey={activeKey}
                onTabSelect={handleTabSelect} />

            <WatrPagePanel>
                {props.subSection != 'VERIFY' &&
                    <WageAndTravelList
                        centerId={props.centerId}
                        isSuperUser={props.isSuperUser}
                        section={props.subSection}
                    />
                }

                {props.subSection == 'VERIFY' &&
                    <VerifyPage isSuperUser={props.isSuperUser} centerId={props.centerId} requestId={props.requestId} />
                }
            </WatrPagePanel>
        </WatrPage>
    );
}

export default WageAndTravel;